import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationsService } from '../../../core/services/notifications.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { UtilityService } from '../../../core/services/utility.service';
import { AccountService } from '../services/account.service';

@Component({
  selector: 'app-namedlogin',
  templateUrl: './namedlogin.component.html',
  styleUrls: ['./namedlogin.component.css']
})
export class NamedloginComponent implements OnInit, OnDestroy {
  portalSettings: any;
  isMobileMode: boolean;
  currentYear: number;
  capsLockOn: boolean;
  isLoading: boolean;
  logoUrl: string;
  welcomeText: string;
  loginErrorMessage: string = "Login failed - please confirm your information and retry. Note that repeated login attempts may lock your account.";

  loginForm = new FormGroup({
    username: new FormControl(null, Validators.required),
    password: new FormControl(null, Validators.required)
  });

  constructor(portalSettingsService: PortalSettingsService, private accountService: AccountService, private notificationsService: NotificationsService, private utilityService: UtilityService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.isMobileMode = this.utilityService.isMobileMode();
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit(): void {
    document.body.style.backgroundImage = "url('/Cache/images/trimble-background.png')";
    window.addEventListener('keyup', (event) => this.capsLockEvent(event));
    window.addEventListener('resize', (event) => this.windowResizeEvent(event));

    let logoCo = this.portalSettings.LogoHQCo.ConfigValue ?? 1;
    this.setLogoUrl(logoCo);

    this.welcomeText = this.portalSettings.LoginWelcomeRichText.ConfigValue;
  }

  ngOnDestroy(): void {
    window.removeEventListener('keyup', (event) => this.capsLockEvent(event));
    window.removeEventListener('resize', (event) => this.windowResizeEvent(event));
  }

  capsLockEvent(event: KeyboardEvent) {
    this.capsLockOn = event.getModifierState && event.getModifierState('CapsLock');
  }

  windowResizeEvent(event) {
    if (window.innerWidth < 768)
      this.isMobileMode = true;
    else
      this.isMobileMode = false;
  }

  login() {
    if (this.loginForm.value.username == null || this.loginForm.value.password == null) {
      this.notificationsService.showError("Please enter your username and/or password", window.location.pathname);
      return;
    }

    this.isLoading = true;
    this.accountService.namedLogin(this.loginForm.value.username, this.loginForm.value.password).then((response: any) => {
      if (response.success) {
        window.location.href = '/';
      }
      else {
        this.isLoading = false;
        this.notificationsService.showError(this.loginErrorMessage, window.location.pathname);
      }
    }).catch((error) => {
      this.isLoading = false;
      this.notificationsService.showError("Error occurred while trying to login, contact your administrator.", window.location.pathname);
    });
  }

  setLogoUrl(co: number, size: string = 'L') {
    this.logoUrl = '/Company/GetLogo?co=' + co + '&size=' + size;
  }
}
